import type { FC } from "react"
import React from "react"

import styled from "styled-components"
import { fontWeight } from "styled-system"

const ElementWrapper = styled.div`
  height: 100px;
  display: flex;
  justify-self: stretch;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 10px;
`
const IconWrapper = styled.div`
  flex-grow: 0;
  padding-left: 27px;
  padding-right: 15px;
  padding-bottom: 5px;
  img {
    width: 37px;
    height: 51px;
    align-self: center;
    justify-self: center;
  }
  p {
    text-transform: uppercase;
    font-size: 10px;
    ${fontWeight(700)};
    text-align: center;
    color: var(--white);
    position: relative;
    top: 35px;
  }
`
const FileInfo = styled.div`
  flex-grow: 1;
  max-width: 100%;
  padding-top: 9px;
  h3,
  p {
    line-height: 19px;
    font-size: 14px;
    color: var(--grey-dark);
  }
  h3 {
    ${fontWeight(600)};
  }
`
const ButtonWrapper = styled.div`
  padding: 0 30px;
  display: flex;
  gap: 30px;
`
const CancelXButton = styled.div`
  position: relative;
  bottom: 5px;
  width: 20px;
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  &::before,
  ::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 3px;
    background: var(--blue);
  }
  &::before {
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(-45deg);
  }
  &:hover {
    ::before,
    ::after {
      height: 4px;
    }
  }
`
const Checkmark = styled.div`
  align-self: flex-end;
  display: inline-block;
  transform: rotate(45deg);
  height: 20px;
  width: 11px;
  border-bottom: 4px solid var(--success-green);
  border-right: 4px solid var(--success-green);
`
const Spinner = styled.div`
  border: 8px solid #f3f3f3;
  border-top: 8px solid var(--blue);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

interface IFileElementProps {
  fileType: string
  file: string
  convertedFileSize: string
  fileName: string
  clearInput: (e: React.MouseEvent) => void
  isUploaded: boolean
  isLoading: boolean
}

export const FileElement: FC<IFileElementProps> = ({
  fileType,
  file,
  fileName,
  convertedFileSize,
  clearInput,
  isUploaded,
  isLoading,
}) => {
  return (
    <ElementWrapper>
      <IconWrapper>
        <p>{fileType}</p>
        <img src={file} alt="file" />
      </IconWrapper>
      <FileInfo>
        <h3>{fileName}</h3>
        <p>{convertedFileSize}</p>
      </FileInfo>
      <ButtonWrapper>
        {isLoading && <Spinner />}

        {isUploaded && !isLoading && (
          <CancelXButton
            onClick={(e) => {
              clearInput(e)
            }}
          />
        )}

        {isUploaded && <Checkmark />}
      </ButtonWrapper>
    </ElementWrapper>
  )
}
